<template>
  <argon-badge v-if="type == 'coworking'" size="sm" color="primary">{{$t('Coworking')}}</argon-badge>
  <argon-badge v-else-if="type == 'coliving'" size="sm" color="primary">{{$t('Coliving')}}</argon-badge>
  <argon-badge v-else size="sm" color="danger">{{$t('Sconosciuto')}}</argon-badge>
</template>

<script>
import ArgonBadge from "@/components/ArgonBadge.vue";

export default {
  name: "EdificioTypeBadge",
  components: {ArgonBadge},
  props: {
    type: {
      type: String,
      default: ""
    }
  }
};
</script>
